function Item(props) {
  
return (
	<div className="py-12 container-video">
		<div className="container">
			<div className="row">
				<div className="col-12 col-md-6">
					<div className="embed-responsive embed-responsive-16by9">
						<iframe width="100%" height="350" className="object-cover" src={`https://www.youtube.com/embed/${props.data.id.videoId}`} title="YouTube video player" frameBorder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowFullScreen></iframe>
					</div>
				</div>
				<div className="col-12 offset-md-1 col-md-5">
					<div className="flex h-100 flex-column justify-content-center">
						<h3 className="mt-3 mb-2 text-2xl text-black mt-md-0 noe">{props.data.snippet.title}</h3>
						<p>{props.data.snippet.description}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
)}
 

export default Item;